import { Trans } from "@lingui/macro";
import { useLingui } from "@lingui/react";
import { useStats } from "react-instantsearch-core-v7";
import { StatsContainer } from "./Facets.styled";

function Stats(): JSX.Element {
  const { nbHits } = useStats();
  const { i18n } = useLingui();

  return (
    <StatsContainer>
      {i18n.number(nbHits)} <Trans>results</Trans>
    </StatsContainer>
  );
}

export { Stats };
